import { Section } from "./Section";
import { Reveal } from "./Reveal";
import { LeadDialog } from "./LeadDialog";
import { Button } from "../ui/button";
import { BOOKING_STEPS } from "../../config/site";

export const BookingSteps = () => (
  <Section
    id="booking"
    className="bg-sand/50"
    overline="How booking works"
    title="Five steps to your factory plot"
  >
    <ol className="grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
      {BOOKING_STEPS.map((s, i) => (
        <Reveal key={s.title} delay={i * 0.08}>
          <li
            className="relative h-full border border-border bg-paper-light p-6 transition-transform duration-200 hover:-translate-y-1"
            data-testid={`booking-step-${i + 1}`}
          >
            <span className="font-display text-5xl font-semibold text-gold/50">{String(i + 1).padStart(2, "0")}</span>
            <h3 className="mt-4 font-display text-xl font-medium text-forest">{s.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-[#4A4C4A]">{s.desc}</p>
          </li>
        </Reveal>
      ))}
    </ol>
    <Reveal delay={0.2}>
      <div className="mt-10 text-center">
        <LeadDialog type="site_visit">
          <Button
            size="lg"
            className="bg-forest text-paper hover:bg-forest-light transition-colors duration-200"
            data-testid="booking-start-button"
          >
            Start with Step 1 — Book a Site Visit
          </Button>
        </LeadDialog>
      </div>
    </Reveal>
  </Section>
);
